// Store original inch values in a data attribute
document.querySelectorAll('.inchitem').forEach(item => {
    item.dataset.inchValue = item.innerText; // Save original inch value
});

// Function to convert inches to centimeters
function convertToCm() {
    document.querySelectorAll('.inchitem').forEach(item => {
        const inches = parseFloat(item.dataset.inchValue);
        item.innerText = Math.round(inches * 2.54); // Convert and display in cm (rounded to nearest whole number)
    });
    // Update button states
    document.getElementById('cmButton').classList.add('active');
    document.getElementById('inchButton').classList.remove('active');
}

// Function to convert back to inches (default state)
function convertToInches() {
    document.querySelectorAll('.inchitem').forEach(item => {
        item.innerText = item.dataset.inchValue; // Restore original inch value
    });
    // Update button states
    document.getElementById('inchButton').classList.add('active');
    document.getElementById('cmButton').classList.remove('active');
}











// Off canvas
function openOffcanvas() {
    document.getElementById("offcanvas").classList.add("show");
  }

  function closeOffcanvas() {
    document.getElementById("offcanvas").classList.remove("show");
  }

  // Close offcanvas if user clicks outside of it
  window.onclick = function(event) {
    if (event.target === document.getElementById("offcanvas")) {
      closeOffcanvas();
    }
  };